import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';
import { useField } from 'formik';
import { getRouteByName } from 'app/routes';

export const collectorsWhere = JSON.stringify({
  isActive: true,
  //guid: { $not: Collector_Unmanned_Guid },
});

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getCollectors(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: id
        description: name
      }
      recordCount
    }
  }
`;

export function useGetCollectorAsOptionsQuery() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
}

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
}

export const FieldSelectCollector = ({
  label = 'Συλλέκτης',
  name = 'collectorId',
  defaultValues = {},
  size = 'sm',
  ...rest
}: LcFsProps) => {
  const { t } = useTranslation();
  label = t(label);
  const where = JSON.stringify({ isActive: true, isSystem: false });

  const [field, { value }] = useField(name);
  const path = value ? generatePath(getRouteByName('Collector'), { id: value }) : '';
  const showLabel = value ? <Link to={path}>{label}</Link> : label;

  return (
    <FieldSelectDB
      height={size === 'lg' ? 32 : '22'}
      {...rest}
      label={showLabel}
      name={name}
      where={where}
      hook={useGetCollectorAsOptionsQuery}
      defaultValues={defaultValues}
    />
  );
};

